import script from "./HelpIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpIndex.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/HelpIndex.css?vue&type=style&index=0&id=372ca6c2&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-372ca6c2"]])

export default __exports__